import { rootApi } from './rootApi';

rootApi.enhanceEndpoints({
  addTagTypes: ['Questions'],
});

export const questionsApi = rootApi.injectEndpoints({
  endpoints(build) {
    return {
      getQuestions: build.query({
        query: (params) => ({ url: '/ContactUs/', method: 'get', params }),
        providesTags: () => {
          return [{ type: 'Questions' }];
        },
      }),
      sendQuestion: build.mutation({
        query: ({ ...data } = {}) => ({
          url: '/ContactUs/',
          method: 'post',
          data,
        }),
        invalidatesTags: () => {
          return [{ type: 'Questions' }];
        },
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSendQuestionMutation } = questionsApi;
